import { Store } from '@toeverything/infra';
import type { Observable } from 'rxjs';

import type { WorkspaceDBService } from '../../db';
import {
  FEATURE_KEY_COLLECTIONS,
  isProductFeatureAllowed,
} from '../../streamlain/hooks/product-feature-gates';

export interface PinnedCollectionRecord {
  collectionId: string;
  index: string;
}

export class PinnedCollectionStore extends Store {
  constructor(private readonly workspaceDBService: WorkspaceDBService) {
    super();
  }

  private assertCollectionsFeatureEnabled() {
    if (!isProductFeatureAllowed(FEATURE_KEY_COLLECTIONS)) {
      throw new Error('Collections feature is disabled');
    }
  }

  watchPinnedCollectionDataReady() {
    return this.workspaceDBService.db.pinnedCollections.isReady$;
  }

  watchPinnedCollections(): Observable<PinnedCollectionRecord[]> {
    return this.workspaceDBService.db.pinnedCollections.find$();
  }

  addPinnedCollection(record: PinnedCollectionRecord) {
    this.assertCollectionsFeatureEnabled();

    this.workspaceDBService.db.pinnedCollections.create({
      collectionId: record.collectionId,
      index: record.index,
    });
  }

  removePinnedCollection(collectionId: string) {
    this.assertCollectionsFeatureEnabled();

    this.workspaceDBService.db.pinnedCollections.delete(collectionId);
  }
}
